export class StoppageTypeDto {
  stoppageTypeId!: number;
  stoppageType!: string;
  colourHex?: string;

  constructor(data: Partial<StoppageTypeDto>) {
    Object.assign(this, data);
  }
}